/* global google */
import classnames from 'classnames';
import React from 'react';
import styles from './Places.module.scss';

export default class Places extends React.Component {
  constructor(props) {
    super(props);
    this.autocompleteInput = React.createRef();
    this.autocomplete = null;
    this.handlePlaceChanged = this.handlePlaceChanged.bind(this);
  }

  componentDidMount() {
    this.autocomplete = new google.maps.places.Autocomplete(
      this.autocompleteInput.current,
      { types: ['geocode'] },
    );

    this.autocomplete.addListener('place_changed', this.handlePlaceChanged);
  }

  handlePlaceChanged() {
    const place = this.autocomplete.getPlace();
    this.props.onPlaceLoaded(place);
  }

  render() {
    return (
      <div className={classnames(this.props.style || styles.container)}>
        <input
          className={this.props.customInputStyles || styles.input}
          ref={this.autocompleteInput}
          id="autocomplete"
          placeholder={this.props.placeholder || 'City & State'}
          type="text"
          defaultValue={this.props.value}
          onChange={this.props.onPlaceLoaded}
        />
      </div>
    );
  }
}
